// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../css-loader/dist/cjs.js!./dialog.responsive.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* CSS for the accessible modal dialogs created by dialog.ts */
/* dialog host */
#profile-modal {
  --profile-modal-backdrop: var(--overlay-bg-muted, rgba(0, 0, 0, 0.5));
  --profile-modal-panel-inline-padding: var(--spacing-lg, 1.5625rem);
  --profile-modal-panel-block-padding: var(--spacing-md, 1.25rem);
  --profile-modal-compact-padding: var(--spacing-sm, 0.9375rem);
  --profile-modal-button-gap: var(--spacing-sm, 0.938rem);
  --profile-modal-error-padding: var(--spacing-xs, 0.75rem);
  --profile-modal-panel-width: min(37.5rem, calc(100vw - 2rem));
  --profile-modal-panel-max-width: 37.5rem;
  --profile-modal-panel-max-height: calc(100dvh - 2rem);
  margin: 0;
  padding: 0;
  border: none;
  background: var(--profile-modal-backdrop);
  max-width: none;
  max-height: none;
  width: 100%;
  height: 100%;
  overflow: hidden;
  position: fixed;
  inset: 0;
  z-index: 9999;
  display: grid;
  place-items: center;
  overscroll-behavior: contain;
  padding-top: env(safe-area-inset-top);
  padding-right: 0;
  padding-bottom: max(var(--spacing-lg, 1.5625rem), env(safe-area-inset-bottom));
  padding-left: 0;
}

#profile-modal:not([open]) {
  display: none;
}

#profile-modal::backdrop {
  background: var(--profile-modal-backdrop);
}

#profile-modal .modal {
  box-sizing: border-box;
  position: relative;
  display: grid;
  grid-template-rows: auto minmax(0, 1fr) auto auto;
  margin: 0;
  background: var(--color-background);
  border-radius: var(--border-radius-base);
  max-width: var(--profile-modal-panel-max-width);
  width: var(--profile-modal-panel-width);
  max-height: var(--profile-modal-panel-max-height);
  overflow: hidden;
  box-shadow: var(--box-shadow-modal, 0 2px 10px rgba(0, 0, 0, 0.3));
  align-self: center;
}

#profile-modal .modal .modal-header {
  gap: var(--spacing-lg);
  width: 100%;
  min-width: 0;
  padding: var(--profile-modal-panel-block-padding) var(--profile-modal-panel-inline-padding); 
  box-sizing: border-box;
  border-radius: var(--border-radius-base, 0.3125rem) var(--border-radius-base, 0.3125rem) 0 0;
  border-bottom: var(--border-width-sm, 0.1rem) solid var(--color-border-lighter, var(--slate-200, #E2E8F0));
  background: var(--color-surface-overlay-header, var(--slate-50, #F8FAFC));
}

#profile-modal .modal #modal-desc {
  min-height: 0;
  overflow: auto;
  overscroll-behavior: contain;
  width: 100%;
  min-width: 0;
  padding: var(--profile-modal-panel-inline-padding);
  box-sizing: border-box;
}

#profile-modal .modal #modal-desc:has(> .profile__edit-form--projects) {
  padding: var(--spacing-2xs, 0.625rem) var(--profile-modal-panel-inline-padding);
}

#profile-modal .modal #modal-desc:has(> #contacts-addressbook-picker-dialog) {
  padding-top: 0;
}

#profile-modal #modal-desc > .profile__edit-form--projects {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-2xs, 0.625rem);
}

#profile-modal .modal #modal-title {
  margin: 0;
  color: var(--color-text-subheading, var(--gray-900, #101828));
}

#profile-modal .modal #modal-header-action > solid-ui-button[aria-label="Close dialog"] {
  --button-height-sm: var(--icon-base, 2rem);
  --button-width-sm: var(--icon-base, 2rem);
  --button-padding-sm: 0;
  --button-background: transparent;
  --button-border-width: 0;
  --button-border: transparent;
  --button-text: var(--color-text);
  --button-border-radius: 999px;
  --button-box-shadow: none;
  --button-hover-background: rgba(0, 0, 0, 0.04);
  --button-hover-border: transparent;
  --button-hover-text: var(--color-primary);
  --button-hover-box-shadow: none;
  --button-active-box-shadow: none;
  --button-active-transform: none;
  --button-icon-size-sm: var(--icon-xxs, 1rem);
}

#profile-modal .modal #modal-header-action > solid-ui-button[aria-label="Close dialog"]:hover {
  --button-hover-background: rgba(0, 0, 0, 0.04);
  --button-hover-border: transparent;
  --button-hover-text: var(--color-primary);
}

#profile-modal .modal #modal-header-action > solid-ui-button[aria-label="Close dialog"]:focus-visible::part(button) {
  outline: var(--focus-indicator-width) solid var(--color-primary);
  outline-offset: var(--outline-offset-sm);
  box-shadow: var(--box-shadow-focus-accessible, 0 0 0 var(--focus-ring-width) var(--color-background), 0 0 0 calc(var(--focus-ring-width) + var(--focus-indicator-width)) var(--color-primary-alpha));
}

#profile-modal .modal:has(#modal-desc > .profile__edit-form--projects) #modal-header-action,
#profile-modal .modal:has(#modal-desc > .profile__edit-form--contact-info) #modal-header-action {
  display: none;
}

#profile-modal .modal solid-ui-button.modal__header-action-button {
  --button-height-sm: 0;
  --button-padding-sm: var(--spacing-xxs);
  --button-background: transparent;
  --button-border-width: 0;
  --button-border: transparent;
  --button-font-weight: var(--font-weight-md, 500);
  --button-text: var(--color-primary);
  --button-hover-background: transparent;
  --button-hover-border: transparent;
  --button-hover-text: var(--color-primary);
}

#profile-modal .modal solid-ui-button.modal__header-action-button:hover::part(button) {
  text-decoration: underline;
}

/* button container: center buttons horizontally (uses id in markup) */
#profile-modal #modal-buttons {
  width: 100%;
  min-width: 0;
  padding: var(--profile-modal-panel-block-padding) calc(var(--profile-modal-panel-inline-padding) + var(--spacing-xxs, 0.3125rem)) var(--profile-modal-compact-padding);
  gap: var(--profile-modal-button-gap);
  align-self: stretch;
  box-sizing: border-box;
  border-top: var(--border-width-sm, 0.1rem) solid var(--color-border-lighter, var(--slate-200, #E2E8F0));
  background: var(--color-surface-tertiary, var(--gray-50, #F9FAFB));
}

#profile-modal #modal-buttons[hidden] {
  display: none !important;
}

#profile-modal #modal-buttons > solid-ui-button {
  width: 10.8rem;
}

#profile-modal #modal-buttons solid-ui-button[data-dialog-primary='true'] {
  --button-font-size-md: var(--font-size-md, 1rem);
}

#profile-modal #modal-buttons solid-ui-button[data-cancel='true'] {
  --button-font-weight: var(--font-weight-normal, normal);
  --button-text: var(--dialog-cancel-button-text, var(--gray-800, #1E2939));
  --button-border: var(--dialog-cancel-button-border, var(--gray-300, #D1D5DC));
  --button-background: var(--dialog-cancel-button-background, transparent);
  --button-hover-background: var(--dialog-cancel-button-hover-background, var(--blue-900, #083575));
  --button-hover-border: var(--dialog-cancel-button-hover-border, var(--blue-900, #083575));
  --button-hover-text: var(--dialog-cancel-button-hover-text, var(--color-text-on-action, var(--white, #FFF)));
  --button-font-size-md: var(--font-size-md, 1rem);
}

#profile-modal #modal-buttons solid-ui-button[data-cancel='true']:hover::part(button),
#profile-modal #modal-buttons solid-ui-button[data-cancel='true']:focus-visible::part(button),
#profile-modal #modal-buttons solid-ui-button[data-cancel='true']:focus-within::part(button) {
  background: var(--dialog-cancel-button-hover-background, var(--blue-900, #083575));
  border-color: var(--dialog-cancel-button-hover-border, var(--blue-900, #083575));
  color: var(--dialog-cancel-button-hover-text, var(--color-text-on-action, var(--white, #FFF)));
}

#profile-modal .modal__error-section {
  margin-top: var(--spacing-sm);
  margin-bottom: 0;
  padding: var(--profile-modal-error-padding);
  border: 1px solid var(--dialog-error-border, var(--pink-700, #ff98b3));
  border-radius: var(--border-radius-base);
  background: var(--dialog-error-background, var(--pink-500, #ffdde6));
  color: var(--dialog-error-text, var(--red-600, #B00020));
  text-align: center;
  white-space: pre-wrap;
  overflow-wrap: anywhere;
}

#profile-modal .modal__error-section[hidden] {
  display: none !important;
}

#profile-modal #modal-saving-overlay {
  position: absolute;
  inset: 0;
  display: grid;
  place-items: center;
  background: rgba(255, 255, 255, 0.78);
  z-index: 10;
}

#profile-modal #modal-saving-overlay[hidden] {
  display: none;
}

#profile-modal.modal--saving #modal-desc {
  opacity: 0.45;
  pointer-events: none;
}

#profile-modal .modal__saving-indicator {
  gap: 0;
}
`, "",{"version":3,"sources":["webpack://./node_modules/profile-pane/lib/ui/dialog.css"],"names":[],"mappings":"AAEA,8DAA8D;AAC9D,gBAAgB;AAChB;EACE,qEAAqE;EACrE,kEAAkE;EAClE,+DAA+D;EAC/D,6DAA6D;EAC7D,uDAAuD;EACvD,yDAAyD;EACzD,6DAA6D;EAC7D,wCAAwC;EACxC,qDAAqD;EACrD,SAAS;EACT,UAAU;EACV,YAAY;EACZ,yCAAyC;EACzC,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,QAAQ;EACR,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,4BAA4B;EAC5B,qCAAqC;EACrC,gBAAgB;EAChB,8EAA8E;EAC9E,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EACb,iDAAiD;EACjD,SAAS;EACT,mCAAmC;EACnC,wCAAwC;EACxC,+CAA+C;EAC/C,uCAAuC;EACvC,iDAAiD;EACjD,gBAAgB;EAChB,kEAAkE;EAClE,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,2FAA2F;EAC3F,sBAAsB;EACtB,4FAA4F;EAC5F,0GAA0G;EAC1G,yEAAyE;AAC3E;;AAEA;EACE,aAAa;EACb,cAAc;EACd,4BAA4B;EAC5B,WAAW;EACX,YAAY;EACZ,kDAAkD;EAClD,sBAAsB;AACxB;;AAEA;EACE,+EAA+E;AACjF;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,iCAAiC;AACnC;;AAEA;EACE,SAAS;EACT,6DAA6D;AAC/D;;AAEA;EACE,0CAA0C;EAC1C,yCAAyC;EACzC,sBAAsB;EACtB,gCAAgC;EAChC,wBAAwB;EACxB,4BAA4B;EAC5B,gCAAgC;EAChC,6BAA6B;EAC7B,yBAAyB;EACzB,8CAA8C;EAC9C,kCAAkC;EAClC,yCAAyC;EACzC,+BAA+B;EAC/B,gCAAgC;EAChC,+BAA+B;EAC/B,4CAA4C;AAC9C;;AAEA;EACE,8CAA8C;EAC9C,kCAAkC;EAClC,yCAAyC;AAC3C;;AAEA;EACE,gEAAgE;EAChE,wCAAwC;EACxC,oMAAoM;AACtM;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,uCAAuC;EACvC,gCAAgC;EAChC,wBAAwB;EACxB,4BAA4B;EAC5B,gDAAgD;EAChD,mCAAmC;EACnC,sCAAsC;EACtC,kCAAkC;EAClC,yCAAyC;AAC3C;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,sEAAsE;AACtE;EACE,WAAW;EACX,YAAY;EACZ,sKAAsK;EACtK,oCAAoC;EACpC,mBAAmB;EACnB,sBAAsB;EACtB,uGAAuG;EACvG,kEAAkE;AACpE;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,uDAAuD;EACvD,yEAAyE;EACzE,6EAA6E;EAC7E,wEAAwE;EACxE,iGAAiG;EACjG,yFAAyF;EACzF,4GAA4G;EAC5G,gDAAgD;AAClD;;AAEA;;;EAGE,kFAAkF;EAClF,gFAAgF;EAChF,8FAA8F;AAChG;;AAEA;EACE,6BAA6B;EAC7B,gBAAgB;EAChB,2CAA2C;EAC3C,sEAAsE;EACtE,wCAAwC;EACxC,oEAAoE;EACpE,wDAAwD;EACxD,kBAAkB;EAClB,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,qCAAqC;EACrC,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,MAAM;AACR","sourcesContent":["@import './dialog.responsive.css';\n\n/* CSS for the accessible modal dialogs created by dialog.ts */\n/* dialog host */\n#profile-modal {\n  --profile-modal-backdrop: var(--overlay-bg-muted, rgba(0, 0, 0, 0.5));\n  --profile-modal-panel-inline-padding: var(--spacing-lg, 1.5625rem);\n  --profile-modal-panel-block-padding: var(--spacing-md, 1.25rem);\n  --profile-modal-compact-padding: var(--spacing-sm, 0.9375rem);\n  --profile-modal-button-gap: var(--spacing-sm, 0.938rem);\n  --profile-modal-error-padding: var(--spacing-xs, 0.75rem);\n  --profile-modal-panel-width: min(37.5rem, calc(100vw - 2rem));\n  --profile-modal-panel-max-width: 37.5rem;\n  --profile-modal-panel-max-height: calc(100dvh - 2rem);\n  margin: 0;\n  padding: 0;\n  border: none;\n  background: var(--profile-modal-backdrop);\n  max-width: none;\n  max-height: none;\n  width: 100%;\n  height: 100%;\n  overflow: hidden;\n  position: fixed;\n  inset: 0;\n  z-index: 9999;\n  display: grid;\n  place-items: center;\n  overscroll-behavior: contain;\n  padding-top: env(safe-area-inset-top);\n  padding-right: 0;\n  padding-bottom: max(var(--spacing-lg, 1.5625rem), env(safe-area-inset-bottom));\n  padding-left: 0;\n}\n\n#profile-modal:not([open]) {\n  display: none;\n}\n\n#profile-modal::backdrop {\n  background: var(--profile-modal-backdrop);\n}\n\n#profile-modal .modal {\n  box-sizing: border-box;\n  position: relative;\n  display: grid;\n  grid-template-rows: auto minmax(0, 1fr) auto auto;\n  margin: 0;\n  background: var(--color-background);\n  border-radius: var(--border-radius-base);\n  max-width: var(--profile-modal-panel-max-width);\n  width: var(--profile-modal-panel-width);\n  max-height: var(--profile-modal-panel-max-height);\n  overflow: hidden;\n  box-shadow: var(--box-shadow-modal, 0 2px 10px rgba(0, 0, 0, 0.3));\n  align-self: center;\n}\n\n#profile-modal .modal .modal-header {\n  gap: var(--spacing-lg);\n  width: 100%;\n  min-width: 0;\n  padding: var(--profile-modal-panel-block-padding) var(--profile-modal-panel-inline-padding); \n  box-sizing: border-box;\n  border-radius: var(--border-radius-base, 0.3125rem) var(--border-radius-base, 0.3125rem) 0 0;\n  border-bottom: var(--border-width-sm, 0.1rem) solid var(--color-border-lighter, var(--slate-200, #E2E8F0));\n  background: var(--color-surface-overlay-header, var(--slate-50, #F8FAFC));\n}\n\n#profile-modal .modal #modal-desc {\n  min-height: 0;\n  overflow: auto;\n  overscroll-behavior: contain;\n  width: 100%;\n  min-width: 0;\n  padding: var(--profile-modal-panel-inline-padding);\n  box-sizing: border-box;\n}\n\n#profile-modal .modal #modal-desc:has(> .profile__edit-form--projects) {\n  padding: var(--spacing-2xs, 0.625rem) var(--profile-modal-panel-inline-padding);\n}\n\n#profile-modal .modal #modal-desc:has(> #contacts-addressbook-picker-dialog) {\n  padding-top: 0;\n}\n\n#profile-modal #modal-desc > .profile__edit-form--projects {\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-2xs, 0.625rem);\n}\n\n#profile-modal .modal #modal-title {\n  margin: 0;\n  color: var(--color-text-subheading, var(--gray-900, #101828));\n}\n\n#profile-modal .modal #modal-header-action > solid-ui-button[aria-label=\"Close dialog\"] {\n  --button-height-sm: var(--icon-base, 2rem);\n  --button-width-sm: var(--icon-base, 2rem);\n  --button-padding-sm: 0;\n  --button-background: transparent;\n  --button-border-width: 0;\n  --button-border: transparent;\n  --button-text: var(--color-text);\n  --button-border-radius: 999px;\n  --button-box-shadow: none;\n  --button-hover-background: rgba(0, 0, 0, 0.04);\n  --button-hover-border: transparent;\n  --button-hover-text: var(--color-primary);\n  --button-hover-box-shadow: none;\n  --button-active-box-shadow: none;\n  --button-active-transform: none;\n  --button-icon-size-sm: var(--icon-xxs, 1rem);\n}\n\n#profile-modal .modal #modal-header-action > solid-ui-button[aria-label=\"Close dialog\"]:hover {\n  --button-hover-background: rgba(0, 0, 0, 0.04);\n  --button-hover-border: transparent;\n  --button-hover-text: var(--color-primary);\n}\n\n#profile-modal .modal #modal-header-action > solid-ui-button[aria-label=\"Close dialog\"]:focus-visible::part(button) {\n  outline: var(--focus-indicator-width) solid var(--color-primary);\n  outline-offset: var(--outline-offset-sm);\n  box-shadow: var(--box-shadow-focus-accessible, 0 0 0 var(--focus-ring-width) var(--color-background), 0 0 0 calc(var(--focus-ring-width) + var(--focus-indicator-width)) var(--color-primary-alpha));\n}\n\n#profile-modal .modal:has(#modal-desc > .profile__edit-form--projects) #modal-header-action,\n#profile-modal .modal:has(#modal-desc > .profile__edit-form--contact-info) #modal-header-action {\n  display: none;\n}\n\n#profile-modal .modal solid-ui-button.modal__header-action-button {\n  --button-height-sm: 0;\n  --button-padding-sm: var(--spacing-xxs);\n  --button-background: transparent;\n  --button-border-width: 0;\n  --button-border: transparent;\n  --button-font-weight: var(--font-weight-md, 500);\n  --button-text: var(--color-primary);\n  --button-hover-background: transparent;\n  --button-hover-border: transparent;\n  --button-hover-text: var(--color-primary);\n}\n\n#profile-modal .modal solid-ui-button.modal__header-action-button:hover::part(button) {\n  text-decoration: underline;\n}\n\n/* button container: center buttons horizontally (uses id in markup) */\n#profile-modal #modal-buttons {\n  width: 100%;\n  min-width: 0;\n  padding: var(--profile-modal-panel-block-padding) calc(var(--profile-modal-panel-inline-padding) + var(--spacing-xxs, 0.3125rem)) var(--profile-modal-compact-padding);\n  gap: var(--profile-modal-button-gap);\n  align-self: stretch;\n  box-sizing: border-box;\n  border-top: var(--border-width-sm, 0.1rem) solid var(--color-border-lighter, var(--slate-200, #E2E8F0));\n  background: var(--color-surface-tertiary, var(--gray-50, #F9FAFB));\n}\n\n#profile-modal #modal-buttons[hidden] {\n  display: none !important;\n}\n\n#profile-modal #modal-buttons > solid-ui-button {\n  width: 10.8rem;\n}\n\n#profile-modal #modal-buttons solid-ui-button[data-dialog-primary='true'] {\n  --button-font-size-md: var(--font-size-md, 1rem);\n}\n\n#profile-modal #modal-buttons solid-ui-button[data-cancel='true'] {\n  --button-font-weight: var(--font-weight-normal, normal);\n  --button-text: var(--dialog-cancel-button-text, var(--gray-800, #1E2939));\n  --button-border: var(--dialog-cancel-button-border, var(--gray-300, #D1D5DC));\n  --button-background: var(--dialog-cancel-button-background, transparent);\n  --button-hover-background: var(--dialog-cancel-button-hover-background, var(--blue-900, #083575));\n  --button-hover-border: var(--dialog-cancel-button-hover-border, var(--blue-900, #083575));\n  --button-hover-text: var(--dialog-cancel-button-hover-text, var(--color-text-on-action, var(--white, #FFF)));\n  --button-font-size-md: var(--font-size-md, 1rem);\n}\n\n#profile-modal #modal-buttons solid-ui-button[data-cancel='true']:hover::part(button),\n#profile-modal #modal-buttons solid-ui-button[data-cancel='true']:focus-visible::part(button),\n#profile-modal #modal-buttons solid-ui-button[data-cancel='true']:focus-within::part(button) {\n  background: var(--dialog-cancel-button-hover-background, var(--blue-900, #083575));\n  border-color: var(--dialog-cancel-button-hover-border, var(--blue-900, #083575));\n  color: var(--dialog-cancel-button-hover-text, var(--color-text-on-action, var(--white, #FFF)));\n}\n\n#profile-modal .modal__error-section {\n  margin-top: var(--spacing-sm);\n  margin-bottom: 0;\n  padding: var(--profile-modal-error-padding);\n  border: 1px solid var(--dialog-error-border, var(--pink-700, #ff98b3));\n  border-radius: var(--border-radius-base);\n  background: var(--dialog-error-background, var(--pink-500, #ffdde6));\n  color: var(--dialog-error-text, var(--red-600, #B00020));\n  text-align: center;\n  white-space: pre-wrap;\n  overflow-wrap: anywhere;\n}\n\n#profile-modal .modal__error-section[hidden] {\n  display: none !important;\n}\n\n#profile-modal #modal-saving-overlay {\n  position: absolute;\n  inset: 0;\n  display: grid;\n  place-items: center;\n  background: rgba(255, 255, 255, 0.78);\n  z-index: 10;\n}\n\n#profile-modal #modal-saving-overlay[hidden] {\n  display: none;\n}\n\n#profile-modal.modal--saving #modal-desc {\n  opacity: 0.45;\n  pointer-events: none;\n}\n\n#profile-modal .modal__saving-indicator {\n  gap: 0;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
